import VODRentingButton from './VODRentingButton_';

export default VODRentingButton;
